"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toE164PhoneNumberStringOrThrow = void 0;
const isE164PhoneNumberString_1 = require("./isE164PhoneNumberString");
function toE164PhoneNumberStringOrThrow(value) {
    if (!(0, isE164PhoneNumberString_1.isE164PhoneNumberString)(value)) {
        throw new Error("Not a valid E.164 phone number string");
    }
    return value;
}
exports.toE164PhoneNumberStringOrThrow = toE164PhoneNumberStringOrThrow;
//# sourceMappingURL=toE164PhoneNumberStringOrThrow.js.map